import { DialogTrigger } from "@light-technology/components";
import { useState, type ReactNode } from "react";
import { api } from "../../state/api";
import type { Webhook } from "../../state/api.types";
import { BasicModal } from "../shared/BasicModal";

type DeleteWebhookModalProps = {
  webhook: Webhook;
  children: ReactNode;
  onSubmit: () => void;
};

export const DeleteWebhookModal = (props: DeleteWebhookModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const [deleteWebhook, deleteWebhookResult] = api.useDeleteWebhookMutation();

  return (
    <DialogTrigger isOpen={isOpen} onOpenChange={setIsOpen}>
      {props.children}
      <BasicModal
        textTitle="Are you sure you want to delete this webhook?"
        textDescription="Any apps using this webhook will stop receiving real-time events."
        textCancel="Cancel"
        textSubmit="Yes, delete"
        isDisabled={false}
        isLoading={deleteWebhookResult.isLoading}
        isDestructive={true}
        onCancel={() => {
          setIsOpen(false);
        }}
        onSubmit={() => {
          deleteWebhook(props.webhook.uuid);
          props.onSubmit();
        }}
        data-ph-capture-attribute-action="delete-webhook"
      />
    </DialogTrigger>
  );
};
